// @ts-nocheck
import * as Types from '../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ProductDetails_LoadQueryVariables = Types.Exact<{
  ccfgId: Types.Scalars['ID'];
  rpogIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type ProductDetails_LoadQuery = { __typename?: 'Query', checkoutConfig: { __typename?: 'CheckoutConfig', id: string, optionGroups: Array<{ __typename?: 'CheckoutConfigOptionGroup', id: string, group: { __typename?: 'ReadyPlanOptionGroup', id: string }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, primaryProduct?: { __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, thumbnail155?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, displayProducts: Array<{ __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, thumbnail155?: string | null | undefined } | null | undefined } | null | undefined }>, option: { __typename?: 'ReadyPlanOption', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } } | null | undefined } }> }> } };

export type ProductDetails_CheckoutConfigPotentialOptionFragment = { __typename?: 'CheckoutConfigPotentialOption', id: string, primaryProduct?: { __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, thumbnail155?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, displayProducts: Array<{ __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, thumbnail155?: string | null | undefined } | null | undefined } | null | undefined }>, option: { __typename?: 'ReadyPlanOption', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } } | null | undefined } };

export type ProductDetailsPackage_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, thumbnail155?: string | null | undefined } | null | undefined } | null | undefined };

export type ProductDetailsSingle_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, displayName: string, listing: { __typename?: 'MaterialListing', id: string, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } };

export const ProductDetailsPackage_MaterialVariantFragmentDoc = gql`
    fragment ProductDetailsPackage_MaterialVariant on MaterialVariant {
  id
  displayName
  featuredImage {
    id
    asset {
      id
      thumbnail155: previewUrl(resizing: {region: FULL, width: 155})
    }
  }
}
    `;
export const ProductDetailsSingle_MaterialVariantFragmentDoc = gql`
    fragment ProductDetailsSingle_MaterialVariant on MaterialVariant {
  id
  displayName
  listing {
    id
    description
    brand {
      id
      name
    }
  }
}
    `;
export const ProductDetails_CheckoutConfigPotentialOptionFragmentDoc = gql`
    fragment ProductDetails_CheckoutConfigPotentialOption on CheckoutConfigPotentialOption {
  id
  primaryProduct {
    ...ProductDetailsPackage_MaterialVariant
  }
  displayProducts {
    ...ProductDetailsPackage_MaterialVariant
  }
  option {
    id
    materialVariant {
      ...ProductDetailsSingle_MaterialVariant
    }
  }
}
    ${ProductDetailsPackage_MaterialVariantFragmentDoc}
${ProductDetailsSingle_MaterialVariantFragmentDoc}`;
export const ProductDetails_LoadDocument = gql`
    query ProductDetails_Load($ccfgId: ID!, $rpogIds: [ID!]!) {
  checkoutConfig(id: $ccfgId) {
    id
    optionGroups(filter: {rpogIds: $rpogIds}) {
      id
      group {
        id
      }
      options {
        ...ProductDetails_CheckoutConfigPotentialOption
      }
    }
  }
}
    ${ProductDetails_CheckoutConfigPotentialOptionFragmentDoc}`;

/**
 * __useProductDetails_LoadQuery__
 *
 * To run a query within a React component, call `useProductDetails_LoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetails_LoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetails_LoadQuery({
 *   variables: {
 *      ccfgId: // value for 'ccfgId'
 *      rpogIds: // value for 'rpogIds'
 *   },
 * });
 */
export function useProductDetails_LoadQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductDetails_LoadQuery, ProductDetails_LoadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductDetails_LoadQuery, ProductDetails_LoadQueryVariables>(ProductDetails_LoadDocument, options);
      }
export function useProductDetails_LoadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductDetails_LoadQuery, ProductDetails_LoadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductDetails_LoadQuery, ProductDetails_LoadQueryVariables>(ProductDetails_LoadDocument, options);
        }
export type ProductDetails_LoadQueryHookResult = ReturnType<typeof useProductDetails_LoadQuery>;
export type ProductDetails_LoadLazyQueryHookResult = ReturnType<typeof useProductDetails_LoadLazyQuery>;
export type ProductDetails_LoadQueryResult = Apollo.QueryResult<ProductDetails_LoadQuery, ProductDetails_LoadQueryVariables>;